/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
  ClickAwayListener, Paper, FormControl, FormGroup, FormControlLabel, Checkbox, Grid, Button,
} from '@material-ui/core';
import useStyles from './styles';

const RolePanel = ({
  rolesSelected, setRolesSelected, onClose, onConfirm,
}) => {
  const classes = useStyles();

  const onChangeRole = useCallback((event) => {
    const { id, checked } = event.currentTarget;

    setRolesSelected(rolesSelected.map((role) => {
      if (role.id === id) {
        role.value = checked;
      }
      return role;
    }));
  }, [rolesSelected, setRolesSelected]);

  const handleConfirm = useCallback(() => {
    onConfirm(rolesSelected);
  }, [onConfirm, rolesSelected]);

  return (
    <div className={classes.container}>
      <ClickAwayListener onClickAway={onClose}>
        <Paper classes={{ root: classes.panel }}>
          <FormControl component="fieldset" className={classes.formControl}>
            <FormGroup>
              {rolesSelected.map((role) => (
                <FormControlLabel
                  key={role.id}
                  id={role.id}
                  classes={{ root: classes.formControlLabel }}
                  control={<Checkbox checked={role.value} id={role.id} onChange={onChangeRole} />}
                  label={role.name}
                  labelPlacement="start"
                />
              ))}
            </FormGroup>
            <Grid container direction="row" justify="flex-end" alignItems="center">
              <Button onClick={onClose}>CANCELAR</Button>
              <Button onClick={handleConfirm}>OK</Button>
            </Grid>
          </FormControl>
        </Paper>
      </ClickAwayListener>
    </div>
  );
};

RolePanel.propTypes = {
  rolesSelected: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    value: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
  setRolesSelected: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default RolePanel;
